import { ValidationErrors, ValidatorFn } from "@angular/forms/src/directives/validators";

/**
 * Возвращает функцию, которая проверяет числовое значение поля формы.
 * Если значение поля больше или равно заданному значению, то поле заполнено неправильно
 * @param maxValue Проверяемое значение
 */
export const getMaxOrEqualsValidator = (maxValue: number): ValidatorFn => {
  return (control): ValidationErrors | null => {
    if (Number.isNaN(control.value) || control.value >= maxValue)
      return { maxOrEquals: { max: maxValue, actual: control.value } };

    return null;
  }
};

/**
 * Возвращает функцию, которая проверяет числовое значение поля формы.
 * Если значение поля меньше или равно заданному значения, то поле заполнено неправильно
 * @param minValue Проверяемое значение
 */
export const getMinOrEqualsValidator = (minValue: number): ValidatorFn => {
  return (control): ValidationErrors | null => {
    if (Number.isNaN(control.value) || control.value <= minValue)
      return { minOrEquals: { min: minValue, actual: control.value } };

    return null;
  }
};



// WEBPACK FOOTER //
// ./src/app/core/utils/validateFunctions.ts